exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media only screen and (min-width:768px){#KuahPau{display:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./src/GuanKiann/TshiuKiSuanTuann/KuahPau.css
// module id = 657
// module chunks = 0